import HighlightedText from '@/app/components/HighlightedText'
import { Icons } from '@/app/components/ui/Icons'
import { LOCATION_TO_TEXT } from '@/app/constants'
import { SearchItemLocationType } from '@/app/types'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { FC, SyntheticEvent } from 'react'
import Text from './Text'

export interface Props {
	type: SearchItemLocationType
	title: string
	locationName: string
	image?: string
	searchTerm: string
}

const SearchAutosuggestItem: FC<Props> = ({
	type,
	title,
	image,
	searchTerm,
	locationName,
}) => {
	const handleImageError = (e: SyntheticEvent<HTMLImageElement>) => {
		const image = e.target as HTMLImageElement
		image.classList.add('hidden')
	}

	const t = useTranslations('Keywords')

	const getCityImage = () => {
		return image ? (
			<>
				<Image
					className="search-autosuggest-item__image rounded relative z-10"
					loading="lazy"
					height={48}
					width={48}
					src={image}
					alt={`${title} image`}
					onErrorCapture={(e) => handleImageError(e)}
				/>
				<Icons.town className="mx-auto mt-3 z-0 absolute w-full h-full left-0 top-0" />
			</>
		) : (
			<Icons.town />
		)
	}

	const renderImage = () => {
		switch (type) {
			case SearchItemLocationType.AIRPORT: {
				return <Icons.plane className="mx-auto my-auto" />
			}
			case SearchItemLocationType.HOTEL: {
				return <Icons.bed className="" />
			}
			case SearchItemLocationType.COUNTRY:
			case SearchItemLocationType.CITY:
			case SearchItemLocationType.FREEREGION:
			case SearchItemLocationType.REGION:
			case SearchItemLocationType.GOOGLE_PLACE:
			case SearchItemLocationType.HOOD:
			case SearchItemLocationType.LM: {
				return getCityImage()
			}
		}
	}

	return (
		<div className="search-autosuggest-item" data-testid="autosuggest-item">
			<div className="rounded-lg flex-shrink-0 overflow-hidden w-12 h-12 bg-text-200 relative flex items-center justify-center">
				{renderImage()}
			</div>
			<div className="ms-3 flex-grow">
				<HighlightedText text={title} highlight={searchTerm} />
				<div className="leading-3">
					<Text size="sm" color="text-700">
						{t(LOCATION_TO_TEXT[type])}
					</Text>
					{locationName ? (
						<>
							<Text size="sm" color="text-700">
								{' '}
								&#8226;{' '}
							</Text>
							<Text size="sm" color="text-700">
								{locationName}
							</Text>
						</>
					) : null}
				</div>
			</div>
		</div>
	)
}

export default SearchAutosuggestItem
